import { random } from './random'

function randomItem<T>(items: T[]): T {
  return items[random(0, items.length - 1)]
}

export { randomItem }
